module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/ko_1-efa1733d2bc5483c5635fbfcc799a2b2.jpg";